import HingeFadeInFromTop from './HingeFadeInFromTop.js';

export default HingeFadeInFromTop;
